import { render, staticRenderFns } from "./AttributeView.vue?vue&type=template&id=e146fae4&scoped=true&"
import script from "./AttributeView.vue?vue&type=script&lang=js&"
export * from "./AttributeView.vue?vue&type=script&lang=js&"
import style0 from "./AttributeView.vue?vue&type=style&index=0&id=e146fae4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e146fae4",
  null
  
)

export default component.exports